import strings from "../i18n/definitions";

export const CEFR_LEVELS = [
  { value: "1", label: "A1 | " + strings.beginner },
  { value: "2", label: "A2 | " + strings.elementary },
  { value: "3", label: "B1 | " + strings.intermediate },
  { value: "4", label: "B2 | " + strings.upperIntermediate },
  { value: "5", label: "C1 | " + strings.advanced },
  { value: "6", label: "C2 | " + strings.proficiency },
];
